import React from 'react'
import { withTranslation } from 'react-i18next'
import FilterPill from '../../shared/FilterPill'
import SearchInput from '../../shared/SearchInput'

export default withTranslation()(function UserFilterBar({ t, q, onChangeQ, branches = [], branch, onChangeBranch, status, onChangeStatus }) {
  const branchOptions = [
    { label: t('settings.user_management.filters.all_branches'), value: '' },
    ...branches.map((b) => ({ label: b.name, value: b.id }))
  ]

  const statusOptions = [
    { label: t('settings.user_management.filters.all_statuses'), value: '' },
    { label: t('settings.user_management.filters.active'), value: 'active' },
    { label: t('settings.user_management.filters.inactive'), value: 'inactive' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <SearchInput
        value={q}
        onChange={onChangeQ}
        placeholder={t('settings.user_management.filters.search_placeholder')}
      />

      <FilterPill
        label={t('settings.user_management.filters.all_branches')}
        active={branch ? { label: branchOptions.find((option) => `${option.value}` === `${branch}`)?.label } : null}
        options={branchOptions}
        onSelect={(option) => onChangeBranch(option.value)}
      />

      <FilterPill
        label={t('settings.user_management.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
      />
    </div>
  )
})
